import React, { useState, useEffect } from "react";
import productData from "../data/products.json"; // Make sure this path is correct
import { Helmet } from "react-helmet";
import ProductDetailedCard from "./ProductDetailedCard";


const Productslideshow = ({showproduct}) => {
  const [product, setProduct] = useState(null);

  const [imageKeys, setImageKeys] = useState([]);

  useEffect(() => {
    // const productSlug = showproduct;
    const foundProduct = productData?.products?.find(
    (p) => p?.str?.toLowerCase() === showproduct
  );

    setProduct(foundProduct);

    if (foundProduct) {
      const keys = ['image', 'image1', 'image2' ,'image3', 'image4', 'image5' , 'image6', 'image7']
        .filter((key) => foundProduct[key]); // only include available keys

      setImageKeys(keys);
    }
  }, [showproduct]);

  const images = imageKeys
    .filter((key) => product[key])
    .map((key) => ({
      src: `/${product[key]}`,
      thumb: `/${product[key]}`, // using same image for thumbnail
      alt: product.name,
    }));


  if (!product) {
    return (
      <div className="text-red-600 text-center py-16 font-semibold text-lg">
        Product not found.
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={`/${product.image}`} />
      </Helmet>
      <ProductDetailedCard product={product} images={images} />
    
    </>
  );
};

export default Productslideshow;
